import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { AuthLayout } from "@/pages/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <AuthLayout
      title="Lupa kata sandi?"
      subtitle="Masukkan email akunmu untuk instruksi reset."
      footer={<Link to="/login" className="font-semibold text-[#7C3AED] hover:underline">Kembali ke Masuk</Link>}
    >
      {sent ? (
        <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-5 text-center" data-testid="reset-success">
          <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-500" />
          <p className="mt-3 text-sm font-medium text-emerald-800">Jika email terdaftar, instruksi reset telah dikirim.</p>
          <p className="mt-1 text-xs text-emerald-600">Fitur reset via email akan segera tersedia.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required data-testid="forgot-email" placeholder="kamu@email.com" value={email}
              onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
          </div>
          <Button type="submit" data-testid="forgot-submit" className="w-full rounded-xl bg-[#7C3AED] py-5 text-base hover:bg-[#6D28D9]">Kirim Instruksi</Button>
        </form>
      )}
    </AuthLayout>
  );
}
